import { TFunction } from "react-i18next";
import { CatalogListResponse } from "../../../../../../../service/catalog/response";
import { getStatus } from "../../../../../../../hooks/status";
import { Constants } from "../../../../../../../utils/constants";
import { format } from "date-fns"


const formatTableResponse = ({ response, t, colors }: { response: CatalogListResponse, t: TFunction<"translation", undefined>, colors: any }) => {

  const totalPages = !response.errors ? response.totalPages:1
  const row = !response.errors
    ? response?.items?.map((item) => {

      return {
        id: item?.id,
        name: item.name,
        createTime: item.createTime && format(new Date(item.createTime), Constants.dateFormatGeneral),
        status: getStatus(item.statusId, colors, t),
        statusId: item.statusId,
        categoriesCount: item.categoriesCount
      }
    })
    : []

  return {
    row,
    totalPages
  }
}


export { formatTableResponse }